import React, { memo } from 'react'
import { Box } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTimerItem } from './TimerItem.hooks'

const TimerItem = props => {
	const [{ classes, timeRemaining, label }] = useTimerItem(props)

	return (
		<Box className={clsx(classes.root, 'cta18-timer-item-block')}>
			<Box className={clsx(classes.value, 'cta18-timer-item-value')}>{timeRemaining}</Box>
			<Box className={clsx(classes.label, 'cta18-timer-item-label')}>{label}</Box>
		</Box>
	)
}

TimerItem.propTypes = {
	fieldConfig: PropTypes.object,
	date: PropTypes.string,
	bgColour: PropTypes.string,
	editable: PropTypes.bool,
	onChange: PropTypes.func,
	onClick: PropTypes.func,
	timeRemaining: PropTypes.number,
}

export default memo(TimerItem)
